import { render, staticRenderFns } from "./edit-recruiters-educational.vue?vue&type=template&id=68c9cc5e&"
import script from "./edit-recruiters-educational.vue?vue&type=script&lang=js&"
export * from "./edit-recruiters-educational.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/QI.Recrutement.FE/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import UiAction from '@/components/ui/action.vue'
import UiContent from '@/components/ui/content.vue'
import UiMaxWidth from '@/components/ui/max-width.vue'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
installComponents(component, {UiAction,UiContent,UiMaxWidth,VBtn,VContainer,VForm})
